import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../utils';

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const categoriesRequest = useRef(null);

  const fetchCategories = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/categories`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategories(response.data.data || []);
    } catch (error) {
      categoriesRequest.current = null;
      console.error('Erreur lors de la récupération des catégories :', error);
    }
  }, []);

  const ensureCategories = useCallback(() => {
    if (!categoriesRequest.current) {
      categoriesRequest.current = fetchCategories();
    }
    return categoriesRequest.current;
  }, [fetchCategories]);

  const fetchProducts = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/products`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(response.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des articles :', error);
    }
  }, []);

  const fetchCustomers = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/customers`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { per_page: 500, sort_by: 'name', sort_direction: 'asc' },
      });
      setCustomers(response.data.data || []);
    } catch (error) {
      console.error('Erreur lors de la récupération des clients :', error);
    }
  }, []);

  const value = useMemo(() => ({
    categories,
    products,
    customers,
    fetchCategories,
    fetchProducts,
    fetchCustomers,
    ensureCategories,
  }), [categories, products, customers, fetchCategories, fetchProducts, fetchCustomers, ensureCategories]);

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => {
  const context = useContext(DataContext);
  const ensureCategories = context?.ensureCategories;

  useEffect(() => {
    ensureCategories?.();
  }, [ensureCategories]);

  return context;
};
